<ng-container *ngIf="fields.fieldType === 'hidden'">
  <!-- HIDDEN FIELD -->
  <div [formGroup]="formGroup">
    <input
      autoFocus
      type="hidden"
      name="prevent_autofill_{{ fields.fieldName }}"
      autocomplete="off"
      [formControlName]="fields.fieldName"
    />
  </div>
</ng-container>
<ng-container *ngIf="fields.fieldType != 'hidden'">
  <div [formGroup]="formGroup" class="w-full py-1 px-2">
    <!-- VISIBLE FIELD -->
    <div *ngIf="fields.fieldType !== 'hidden'" class="gap-1 items-start mb-1">
      <!-- ✅ LABEL ABOVE -->
      <div *ngIf="labelAbove; else sideLayout">
        <label
          [ngClass]="{
            required:
              (fields.isRequired == true ||
                fields.isRequired === 'true' ||
                dynamicRequired === true) &&
              !disableFields,
          }"
          class="block text-2sm font-semibold text-gray-700 dark:text-gray-300 mb-1"
        >
          {{ formatDisplayName(fields.displayName) }}
        </label>

        <div>
          <ng-container *ngTemplateOutlet="inputBlock"></ng-container>
        </div>
      </div>

      <!-- ✅ SIDE LABEL -->
      <ng-template #sideLayout>
        <div class="grid grid-cols-12 gap-3 rounded-lg w-full items-center">
          <!-- LABEL -->
          <div class="col-span-4">
            <label
              [ngClass]="{
                required:
                  (fields.isRequired == true ||
                    fields.isRequired === 'true' ||
                    dynamicRequired === true) &&
                  !disableFields,
              }"
              class="block text-2sm font-semibold text-gray-700 dark:text-gray-300 whitespace-normal break-words leading-tight"
            >
              {{ formatDisplayName(fields.displayName) }}
            </label>
          </div>

          <!-- INPUT -->
          <div class="col-span-8">
            <ng-container *ngTemplateOutlet="inputBlock"></ng-container>
          </div>
        </div>
      </ng-template>

      <!-- ✅ INPUT BLOCK -->
      <ng-template #inputBlock>
        <!-- DATE -->
        <div
          *ngIf="
            fields.fieldType == 'date' &&
            fields.fieldType !== 'textarea' &&
            fields.fieldType !== 'radio'
          "
          class="relative w-full flex items-center cursor-pointer"
        >
          <input
            #focusInput
            (focus)="isFocused = true"
            (blur)="isFocused = false"
            (click)="openDatePicker(focusInput)"
            (keydown)="$event.preventDefault()"
            name="prevent_autofill_{{ fields.fieldName }}"
            autocomplete="off"
            [type]="fields.fieldType"
            [formControlName]="fields.fieldName"
            (input)="onKeyUpValidateFields(fields)"
            (keydown.enter)="$event.preventDefault()"
            class="input w-full text-2sm border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400 dark:focus:ring-blue-900/30 dark:focus:border-blue-500 text-gray-700 dark:text-gray-200 placeholder:text-gray-400 transition-all duration-150 date-input-custom cursor-pointer"
            [placeholder]="fields.placeholder"
            [disabled]="fields.fieldName == 'delay' || disableFields == true"
            [ngClass]="{
              disabled: fields.fieldName == 'delay' || disableFields == true,
              'is-invalid border-danger focus:ring-red-200':
                formGroup.get(fields.fieldName)?.touched &&
                formGroup.get(fields.fieldName)?.invalid,
            }"
          />
          <span
            class="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none text-2sm text-gray-700 dark:text-gray-200 cursor-pointer"
            [ngClass]="{
              'opacity-45':
                fields.fieldName == 'delay' || disableFields == true,
            }"
            [ngStyle]="{
              color: formattedDateValue ? '' : '#808290',
            }"
          >
            {{ formattedDateValue || fields.placeholder || "Select Date" }}
          </span>
        </div>

        <!-- TEXT INPUT -->
        <input
          #focusInput
          *ngIf="
            fields.fieldType != 'textarea' &&
            fields.fieldType != 'date' &&
            fields.fieldType != 'radio'
          "
          [type]="fields.fieldType"
          name="prevent_autofill_{{ fields.fieldName }}"
          autocomplete="off"
          [formControlName]="fields.fieldName"
          (input)="onKeyUpValidateFields(fields)"
          (keydown.enter)="$event.preventDefault()"
          class="input w-full text-2sm border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400 dark:focus:ring-blue-900/30 dark:focus:border-blue-500 text-gray-700 dark:text-gray-200 placeholder:text-gray-400 transition-all duration-150"
          [placeholder]="fields.placeholder"
          [disabled]="fields.fieldName == 'delay' || disableFields == true"
          [ngClass]="{
            disabled: fields.fieldName == 'delay' || disableFields == true,
            'is-invalid border-danger focus:ring-red-200':
              formGroup.get(fields.fieldName)?.touched &&
              formGroup.get(fields.fieldName)?.invalid,
          }"
        />
        <!-- (paste)="onPaste($event, fields.fieldName)" -->
        <!-- ✅ TEXTAREA (FULL WIDTH CONTROLLED BY PARENT GRID) -->
        <textarea
          tabindex="-1"
          #focusInput
          *ngIf="fields.fieldType == 'textarea'"
          name="prevent_autofill_{{ fields.fieldName }}"
          autocomplete="off"
          [formControlName]="fields.fieldName"
          (input)="onKeyUpValidateFields(fields)"
          (keydown.enter)="$event.preventDefault()"
          class="input w-full text-2sm p-3 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400 dark:focus:ring-blue-900/30 dark:focus:border-blue-500 dark:text-gray-200 transition-all duration-150"
          style="height: 90px; resize: none"
          [placeholder]="fields.placeholder"
          [disabled]="fields.fieldName == 'delay' || disableFields == true"
          [ngClass]="{
            disabled: fields.fieldName == 'delay' || disableFields == true,
            'is-invalid border-danger focus:ring-red-200':
              formGroup.get(fields.fieldName)?.touched &&
              formGroup.get(fields.fieldName)?.invalid,
          }"
        ></textarea>

        <!-- ✅ RADIO -->
        <div *ngIf="fields.fieldType === 'radio'" class="flex flex-wrap gap-4">
          <label
            *ngFor="let option of fields.options.staticOptions"
            class="flex items-center justify-center gap-2 cursor-pointer mt-3"
          >
            <input
              type="radio"
              [value]="option.id"
              [formControlName]="fields.fieldName"
              [name]="fields.fieldName"
              autocomplete="off"
              class="radio accent-blue-500 cursor-pointer"
            />

            <span
              class="text-2sm leading-none"
              [ngStyle]="{ color: option.color || '#6b7280' }"
            >
              {{ option.text }}
            </span>
          </label>
        </div>

        <!-- ✅ VALIDATION -->
        <div
          *ngIf="
            formGroup.get(fields.fieldName)?.touched &&
            formGroup.get(fields.fieldName)?.invalid
          "
          class="text-danger text-2sm"
        >
          <!-- ✅ Show ONLY required first -->
          <ng-container
            *ngIf="
              formGroup.get(fields.fieldName)?.errors?.['required'];
              else otherErrors
            "
          >
            Please enter {{ fields.displayName }}
          </ng-container>

          <!-- ✅ Show custom errors ONLY if not required -->
          <ng-template #otherErrors>
            {{ errors[fields.fieldName] }}
          </ng-template>
        </div>
      </ng-template>
    </div>
  </div>
</ng-container>
